import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppPreset } from './shared/lib/configuration/preset/app-preset';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthModule } from './shared/modules/auth/auth.module';
import { DATE_PIPE_DEFAULT_OPTIONS, DatePipeConfig } from '@angular/common';
import { authInterceptor } from './shared/modules/auth/interceptors/auth.interceptor';
import { DialogService } from 'primeng/dynamicdialog';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { timezone: 'America/New_York' } as DatePipeConfig,
    },
    providePrimeNG({
      theme: {
        preset: AppPreset,
        options: {
          darkModeSelector: '.my-app-dark',
        },
      },
    }),
    MessageService,
    ConfirmationService,
    DialogService,
    { provide: DEFAULT_CURRENCY_CODE, useValue: '' },
    importProvidersFrom(AuthModule.forRoot()),
  ],
};
